import { useTranslation } from 'react-i18next'
import { useAuthContext } from '../core/providers/AuthProvider'
import { Navigate, useLocation } from 'react-router-dom'
import { routes } from '../core/routes/paths'

export const ProtectedRoute = ({ children }) => {
    const { t } = useTranslation()
    const { isAuthenticated, isLoading } = useAuthContext()
    const location = useLocation()

    if (isLoading) {
        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100vh',
                    color: 'white',
                    fontSize: '18px',
                }}
            >
                {t('common.loading')}
            </div>
        )
    }

    if (!isAuthenticated) {
        return <Navigate to={routes.main} state={{ from: location }} replace />
    }

    return children
}
